/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type FilterKeywordKind = (typeof FilterKeywordKind)[keyof typeof FilterKeywordKind];

export const FilterKeywordKind = {
  keyword: 'keyword',
} as const;
